import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Tab, Tabs, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomerTab from './CustomerTab';
import DetailTab from './DetailTab';
import DoctorTab from './DoctorTab';
import { Button } from '@material-ui/core';
import InfoTab from './InfoTab';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`reconciliation-tabpanel-${index}`}
      aria-labelledby={`reconciliation-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="tabContent">
          {children}
        </Box>
      )}
    </div>
  );
}

const ActReconciliationMain = ({
                                       data,
                                       edit = false,
                                       detail,
                                       onConfirm,
                                       kontragent,
                                       handleState
                                     }) => {
  const [state, setState] = handleState;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);
  const [editedData, setEditedData] = useState(null);
  const [additionalExpenses, setAdditionalExpenses] = useState([]);

  useEffect(() => {
    if (detail?.additionalExpenses) {
      setAdditionalExpenses(detail.additionalExpenses);
    }
  }, [detail]);

  const groupedData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return edit ? data.map(order => ({
      client: order.client,
      birthday: order.birthday,
      address: order.address,
      doctor: order.doctor,
      date: order.date,
      idOrder: order.idOrder,
      idDoctor: order.idDoctor,
      calcDoctorPart: order.calcDoctorPart,
      items: order.products?.map(item => ({
        date: item.date,
        orderNumber: order.idOrder,
        code: item.code,
        product: item.product,
        idGrTest: item?.idGrTest,
        qtyProduct: item.qtyProduct || 1,
        price: item.price,
        discount: item.discount || 0,
        suma: item.suma,
        priceCalc: item.priceCalc,
        discountPrice: item.discountPrice,
        doctorPart: item.doctorPart,
        defectNotice: item.defectNotice || [],
        defect: item.defect,
        raintake: item.raintake || [],
        pay: item.pay,
        result: item.result || [],
        hasError: (item.defect?.includes(true) || item.defectNotice?.length > 0 || !item.pay),
        hasRaintake: item.raintake?.includes('reintake')
      })) || [],
      clientTotals: {
        qtyProduct: order.qtyProduct || 0,
        price: order.price || 0,
        discount: order.discount || 0,
        suma: order.suma || 0,
        priceCalc: order.priceCalc || 0,
        discountPrice: order.discountPrice || 0,
        doctorPart: order.doctorPart || 0,
      }
    })) : data;
  }, [data]);


  const currentData = editedData || groupedData;


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCustomerDataChange = useCallback((newEditedData) => {
    setEditedData(newEditedData);
  }, []);

  const handleConfirmReport = async (e) => {
    e.persist()
    
   try {
    //  await setDocumentStatus(hash, 2)

    setState(p=>({
      ...p,
      data: {
        ...p.data,
        status: 2
      }
    }))
   } catch (error) {
     console.error('Error confirming report:', error);
   }
  }

  const handleRejectReport = async (e) => {
    e.persist()
    
   try {
    //  await setDocumentStatus(hash, 2)

    setState(p=>({
      ...p,
      rejectDialog: true,
      data: {
        ...p.data,
        status: 4
      }
    }))
   } catch (error) {
     console.error('Error confirming report:', error);
   }
  }

  return (<>
        <div className={classes.header}>
          {state?.data?.type?.name} {state?.data?.status === 'CONFIRMED' ? '(Підтверджено)' : ''}
        </div>

        <Box className={classes.tabsContainer}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="standard"
          >
            <Tab
              label="Клієнти"
              id="reconciliation-tab-0"
              aria-controls="reconciliation-tabpanel-0"
            />
            <Tab
              label="Деталі"
              id="reconciliation-tab-1"
              aria-controls="reconciliation-tabpanel-1"
            />
            <Tab
              label="Лікарі"
              id="reconciliation-tab-2"
              aria-controls="reconciliation-tabpanel-2"
            />
            <Tab
              label="Додаток"
              id="reconciliation-tab-3"
              aria-controls="reconciliation-tabpanel-3"
            />
          </Tabs>
        </Box>

        <div className={classes.tabContent}>
          <TabPanel value={activeTab} index={0}>
            <CustomerTab
              data={currentData}
              onDataChange={handleCustomerDataChange}
              additionalExpenses={additionalExpenses}
              state={state}
            />
          </TabPanel>

          <TabPanel value={activeTab} index={1}>
            <DetailTab
              data={currentData}
            />
          </TabPanel>

          <TabPanel value={activeTab} index={2}>
            <DoctorTab
              state={state}
              data={currentData}
              additionalExpenses={additionalExpenses}
            />
          </TabPanel>
          <TabPanel value={activeTab} index={3}>
            {activeTab === 3 && <InfoTab data={currentData} additionalExpenses={additionalExpenses} onDataChange={setAdditionalExpenses} />}
            </TabPanel>

        </div>

      <div className={classes.actionWrapper}>
        {/* <TextField
          multiline
          minRows={5}
          fullWidth
          label="Коментар до звіту"
          value={''}
          onChange={() => {}}
          disabled={state.data && state.data.status !== 1}
          className={classes.textArea}
          size="small"
          variant="outlined"
        /> */}
        {(state.data && state.data.status !== 'CONFIRMED' && state.data.status !== "REJECTED")  
        && <Button
          variant="contained"
          color="secondary"
          style={{ marginTop: '16px', marginRight: '16px' }}
          onClick={handleRejectReport}
        >
          Скасувати
        </Button>}
        {(state.data && state.data.status !== 'CONFIRMED' && state.data.status !== "REJECTED")  
        && <Button
          variant="contained"
          color="primary"
          style={{ marginTop: '16px' }}
          onClick={handleConfirmReport}
        >
          Підтвердити
        </Button>}
        {(state.data && state.data.status === "REJECTED") && <p style={{color: 'red', margin: '0px auto'}}>
          ВІДМОВА.
          <br/>
          Опрацьовується менеджером.
          <br/>
          <br/>
          Залишений коментар: {state?.data?.note}
        </p> }
      </div>
  </>);
};

export default ActReconciliationMain;

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      maxWidth: '98vw',
      width: '1600px',
      maxHeight: '95vh',
      margin: '8px'
    }
  },
  header: {
    textAlign: 'center',
    backgroundColor: '#ffffff',
    padding: '20px',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  tabsContainer: {
    borderBottom: '1px solid #ccc',
    backgroundColor: '#f5f5f5',
    '& .MuiTabs-root': {
      minHeight: '36px'
    },
    '& .MuiTab-root': {
      fontSize: '12px',
      fontFamily: 'Arial, sans-serif',
      fontWeight: 'bold',
      textTransform: 'none',
      minHeight: '36px',
      padding: '8px 24px',
      border: '1px solid #ccc',
      borderBottom: 'none',
      backgroundColor: '#e8e8e8',
      color: '#000',
      marginRight: '2px',
      borderRadius: '4px 4px 0 0',
      '&.Mui-selected': {
        backgroundColor: '#ffffff',
        color: '#000',
        borderBottom: '1px solid #ffffff',
        zIndex: 1,
        position: 'relative'
      },
      '&:hover': {
        backgroundColor: '#f0f0f0'
      }
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    }
  },
  tabContent: {
    backgroundColor: '#ffffff',
    minHeight: '250px',
  },
  actionWrapper: { 
    padding: '16px',
    display: 'flex',  
    flexDirection: 'row',
    justifyContent: 'flex-end',

  }
}));
